class UnverifiedAddressComponent {
  constructor($scope, $state) {
    Object.assign(this, {
      $scope,
      searchTerm: $state.params.search,
      page: {
        limit: parseInt($state.params.limit),
        offset: (parseInt($state.params.number) - 1) * parseInt($state.params.limit),
      },
    });
  }
}

UnverifiedAddressComponent.$inject = ['$scope', '$state', 'GpAddress', 'Utils', 'Orders', 'GpLettersService'];
angular.module('pims').controller('UnverifiedAddress', UnverifiedAddressComponent);
//
// angular.module('pims').component('unverifiedAddress', {
//   templateUrl: 'app/views/users/gp-letters/tabs/unverified-address/unverified-address.component.html',
//   controller: UnverifiedAddressComponent,
//   controllerAs: 'vm',
//   bindings: {}
// });
